export function initCommentFormFix() {

  const commentForm = document.getElementById('commentform');
  if(commentForm) {
    commentForm.removeAttribute('novalidate');
  }

}